import React from "react";
import { classNames } from "../../helpers/classNames";

const Form = ({
  onSubmit = () => {},
  loading,
  children,
  handleSubmit = () => {},
  className,
}) => {
  return (
    <form
      className={classNames("space-y-7 relative", className)}
      onSubmit={(event) => handleSubmit(event, onSubmit)}
    >
      {children}
      {loading && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <span className="text-xl font-semibold text-gray-700 flex items-center gap-2">
            <i className="fa-fw fa-duotone text-2xl fa-solid fa-spinner-third animate-spin"></i>
            Loading...
          </span>
        </div>
      )}
    </form>
  );
};

export default Form;
